<template>
<html lang="en">
  <head>
    <meta charset="utf-8">
    <meta name="viewport" content="width=device-width, initial-scale=1">
    <meta name="description" content="">
    <meta name="author" content="Sylva Foundation">
    <meta name="generator" content="Hugo 0.84.0">
    <title>Forestry and Climate Change Partnership</title>


    
    <!-- Custom styles for this template -->
  </head>
  <body>

  <!-- Marketing messaging and featurettes
  ================================================== -->
  <!-- Wrap the rest of the page in another container to center all the content. -->

<div class="container marketing">
  <div class="row mb-3">
    <div class="col-lg mb-3">
      <h3 class="greeni">
      Support
      </h3>
    </div>
	<h5 class="greeni mb-3">
	Get Involved
	</h5>
    <p>
	There are a number of ways that can you get involved in the work of the FCCP:
    </p> 
	<div>
		<ul>
			<li> sign up to our mailing list (see below) </li>
			<li> attend a training session or seminar (see our latest events) </li>
			<li> offer to host an event or support training </li>
			<li> donate to support our work – please contact one of our member organisations and mention FCCP </li>
			<li> read more about our core work and spread the word </li>
		</ul>
	</div>
	<p>
	Organisations can sign up as supporters of the Forestry &amp; Climate Change Adaptation Accord - <a href="https://forms.gle/umd1PsgYRxz15PZJ9" target="__blank" class="greeni">click here</a>.
	</p>
  </div>
  <div class="row">
	<div class="col-lg">
		<h5 class="greeni mb-3">
			Join our Mailing List
		</h5>
		<p>
		If you are interested in our future events and activities, sign up below. Your personal information will be managed by Sylva Foundation on behalf of the FCCP, but no personal data will be shared with other organisations within the partnership. <a class="greeni" href="https://www.sylva.org.uk/privacy">Read Sylva Foundation’s Privacy Notice.</a>
		</p>
		<div class="frame mb-3">
			<iframe src="https://cdn.forms-content.sg-form.com/18a60662-f7b7-11ec-9f41-32f3aea66bf9" width="100%" height="640" frameborder="0" marginheight="0" marginwidth="0">Loading…</iframe> 
		</div>
	</div>
  </div>
  <div class="row">
	<div class="col-lg">
		<h5 class="greeni mb-3">
			Contact Us
		</h5>
		<p>
		If you wish to get in touch with us about our work, please contact the Chair or Secretary of the FCCP by using the contact form below.
		</p>
	</div>
  </div>
  <div class="row">
	<contact-form></contact-form>
  </div>
</div>
      
  </body>
</html>
</template>

<script>
import ContactForm from './ContactForm.vue'
export default {
	components: { ContactForm },
	name: 'Support',
	props: {
	}
}

</script>

<style>

</style>